<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    mode="out-in"
    enter-active-class="transition-opacity ease-in-out duration-200"
    leave-active-class="transition-opacity ease-in-out duration-200"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
